<ds-configuration-search-page
  [fixedFilterQuery]="fixedFilter"
  [configuration]="configuration"
  [configuration$]="configuration$"
  [searchEnabled]="searchEnabled"
  [sideBarWidth]="sideBarWidth">
</ds-configuration-search-page>
